module.exports = __webpack_public_path__ + "static/media/anquan.f1ec1307.svg";